import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const TAX_CLASS_URL = `${API_URL}/api/tax-classes/`;

export interface TaxClassModel {
  id: number;
  code: string;
  name: string;
  country: string;
}

export function listTaxClasses(country?: string): Promise<{ data: TaxClassModel[] }> {
  return axios.get(TAX_CLASS_URL, { params: { country } });
}
